import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { getEnvironment } from '../../../../shared/utils/helpers';
import PropTypes from 'prop-types';

const CreateContractorGroupMutation = (variables, callback) => {
  commitMutation(getEnvironment(), {
    mutation: graphql`
      mutation CreateContractorGroupMutation($input: CreateContractorGroupInput!) {
        createContractorGroup(input: $input) {
          newGroup {
            id
          }
        }
      }
    `,
    variables: {
      input: variables
    },
    onCompleted: (response, errors) => {
      callback(response.createContractorGroup, errors);
    },
    onError: err => console.error(err)
  });
};

CreateContractorGroupMutation.propTypes = {
  variables: PropTypes.objectOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      contractors: PropTypes.array.isRequired,
      isPublic: PropTypes.bool.isRequired
    })
  )
};

export default CreateContractorGroupMutation;
